import { Button, Modal, Tooltip } from "@material-ui/core";
import { Box } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useMemo, useState } from "react";
import { Edit3 } from "react-feather";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { fdelete, fpatch } from "../../../API/callsAPI";
import { renderFieldContent } from "../../Utilities/CustomTableForAllTrackables/CustomTableBodyForAllTrackables";
import DeleteModal from "../../Utilities/DeleteModal/DeleteModal.component";
import useStyles from "./SequenceCustomTable.styles";
import SequencePageEditSequenceModal from "../SequencePageModals/SequencePageEditSequenceModal";

const SequenceCustomTable = ({
  sequenceList,
  projectId,
  statusList,
  updateRefreshCounter,
  setSnackValue,
  allFieldsConfig,
  handleAssetDetailModalState,
  taskList,
  fetchTasks,
  dragScreen,
  handleDragScreen,
  setDragFileEnterModal,
  setViewMode,
}) => {
  const classes = useStyles();
  const history = useHistory();
  const [deleteSequenceModalOpen, setDeleteSequenceModalOpen] = useState({
    open: false,
    data: {},
  });
  const [isEditSequenceModalOpen, setEditSequenceModalOpen] = useState({
    open: false,
    data: {},
  });

  function handleDeleteSequenceModalState(e, data) {
    e?.stopPropagation();
    setDeleteSequenceModalOpen({ open: true, data: data });
  }

  function handleEditSequenceModalState(e, data) {
    e?.stopPropagation();
    setEditSequenceModalOpen({ open: true, data: data });
  }

  const handleDeleteSequence = async () => {
    try {
      await fdelete({
        url: `trackables/shot-sequence/${deleteSequenceModalOpen.data?.id}/`,
      });
      updateRefreshCounter();
      setDeleteSequenceModalOpen({
        open: false,
        data: {},
      });
      setEditSequenceModalOpen({
        open: false,
        data: {},
      });
    } catch (error) {
      console.log(error);
    }
  };

  const rows = useMemo(
    () =>
      (sequenceList?.results ?? []).map((res) => ({
        id: res.id,
        ...res,
      })),
    [sequenceList?.results],
  );

  const handleValueChange = async (fieldName, value, id) => {
    try {
      const res = await fpatch({
        url: `trackables/shot-sequence/v2/${id}/`,
        data: {
          [fieldName]: value,
        },
      });
      if (res.status === 200 || res.status === 201) {
        updateRefreshCounter();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleRowClick = (params, event) => {
    if (setViewMode) {
      setViewMode({
        sequence: false,
        shots: true,
        seqId: params.row.id,
        seqName: params.row.code,
        shotId: null,
        shotName: null,
      });
    } else {
      if (event.ctrlKey) {
        window.open(`/${projectId}/sequence/${params.row.id}/shots`);
        sessionStorage.setItem("scrollpos", window.scrollY);
      } else {
        history.push(`/${projectId}/sequence/${params.row.id}/shots`);
        sessionStorage.setItem("scrollpos", window.scrollY);
      }
    }
  };

  const columns = [
    ...(allFieldsConfig ?? []).map((field) => ({
      field: field.name,
      headerName: field.label || field.name,
      minWidth: 190,
      flex: 1,
      sortable: true,
      renderCell: (params) => (
        <div
          style={{
            width: "100%",
            minHeight: "100%",
            display: "flex",
            alignItems: "center",
          }}
        >
          {renderFieldContent({
            field,
            props: { data: params.row },
            handleValueChange: (fieldName, value) =>
              handleValueChange(fieldName, value, params.row.id),
            index: 0,
            statusUrl: `trackables/sequence/${params.row.id}/`,
            statusList,
            updateRefreshCounter,
          })}
        </div>
      ),
    })),
    {
      field: "actions",
      headerName: "Actions",
      minWidth: 190,
      sortable: false,
      renderCell: (params) => {
        const data = params.row;
        return (
          <Tooltip title="Edit Asset" placement="top">
            <Button
              id="editAssetVersion"
              className={classes.inlineButtons}
              onClick={(e) => handleEditSequenceModalState(e, params.row)}
            >
              <Edit3 size={18} />
            </Button>
          </Tooltip>
        );
      },
    },
  ];

  return (
    <Box
      className={classes.assetsTableContainer}
      sx={{
        height:
          sequenceList?.count > 50
            ? "calc(100vh - 230px)"
            : "calc(100vh - 200px)",
        width: "100%",
        overflowX: "auto",
      }}
    >
      <DataGrid
        rows={rows}
        columns={columns}
        disableSelectionOnClick
        onRowClick={handleRowClick}
        hideFooter
        sx={{
          width: "max-content",
          minWidth: "100%",
          border: "none",
          bgcolor: "transparent",
          "& .MuiDataGrid-root": {
            background: "#1B1D28 !important",
            color: "#606479 !important",
          },
          "& .MuiDataGrid-cell": {
            borderTop: "1px solid #606479 !important",
            alignItems: "center",
          },
          "& .MuiDataGrid-row": {
            cursor: "pointer",
            backgroundColor: "#1B1D28",
            color: "#f9f9f9",
          },
          "& .MuiDataGrid-main": {
            minWidth: "max-content",
          },
          "& .MuiDataGrid-virtualScroller": {
            overflowX: "auto",
          },
          "& .MuiDataGrid-window": {
            overflowX: "auto",
          },
          "& .MuiDataGrid-footerContainer": {
            display: "none",
          },
          //
          "& .MuiDataGrid-container--top [role='row'], & .MuiDataGrid-container--bottom [role='row']":
            {
              backgroundColor: "#1B1D28 !important",
              borderColor: "#606479",
              borderTop: "1px solid #606479",
              padding: "0px",
            },

          "--DataGrid-rowBorderColor": "#606479",
          "& .MuiDataGrid-columnHeaders": {
            color: "#606479",
            fontSize: {
              xs: "8px",
              sm: "10px",
              md: "12px",
              lg: "14px",
              xl: "16px",
            },
          },
        }}
        slots={{
          noRowsOverlay: () => (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
              }}
            >
              No shots found.
            </Box>
          ),
        }}
      />
      <Modal
        className={classes.sequencePageModals}
        open={deleteSequenceModalOpen.open}
        onClose={() =>
          setDeleteSequenceModalOpen({
            open: false,
            data: {},
          })
        }
      >
        <DeleteModal
          type="Sequence"
          name={
            deleteSequenceModalOpen.data?.name ||
            deleteSequenceModalOpen.data?.code
          }
          handleCloseDeleteModal={() => {
            setDeleteSequenceModalOpen({
              open: false,
              data: {},
            });
          }}
          handleDelete={handleDeleteSequence}
        />
      </Modal>

      <Modal
        className={classes.sequencePageModals}
        open={isEditSequenceModalOpen.open}
        onClose={() =>
          setEditSequenceModalOpen({
            open: false,
            data: {},
          })
        }
      >
        <SequencePageEditSequenceModal
          dragScreen={dragScreen}
          handleDragScreen={handleDragScreen}
          setDragFileEnterModal={setDragFileEnterModal}
          status={statusList}
          projectId={projectId}
          sequenceId={isEditSequenceModalOpen.data?.id}
          sequence={isEditSequenceModalOpen.data}
          handleEditSequenceModal={() =>
            setEditSequenceModalOpen({
              open: false,
              data: {},
            })
          }
          handleDeleteSequenceModalState={handleDeleteSequenceModalState}
          updateRefreshCounter={updateRefreshCounter}
          customFields={sequenceList.custom_fields}
        />
      </Modal>
    </Box>
  );
};

export default SequenceCustomTable;
